module.exports = __webpack_public_path__ + "media/images/austrian/offers/digital-voucher-app1x-b1919a154131e6076df5aadf6eb80b56.jpg";